var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 22.5,
    viewBox: "0 0 22.5 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-edit_1_",
    "data-name": "file-edit (1)",
    d: "M11.25,6.563V.431a6.541,6.541,0,0,1,2.311,1.491L16.827,5.19A6.519,6.519,0,0,1,18.319,7.5H12.188a.938.938,0,0,1-.938-.938Zm1.191,11.7a4.063,4.063,0,0,0-1.191,2.873V22.5h1.364a4.063,4.063,0,0,0,2.873-1.191l2.318-2.318,4.063-4.063a2.154,2.154,0,1,0-3.047-3.047l-6.382,6.382ZM9.375,21.136a5.9,5.9,0,0,1,1.739-4.2L17.5,10.555a4.036,4.036,0,0,1,1.248-.845c0-.113-.008-.224-.016-.337h-6.54A2.816,2.816,0,0,1,9.375,6.562V.023C9.224.012,9.073,0,8.92,0H4.688A4.693,4.693,0,0,0,0,4.688V17.813A4.693,4.693,0,0,0,4.688,22.5H9.375Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillEditIcon);
export default __webpack_public_path__ + "static/media/fill_edit_icon.36553a8bb9dcbf36a581efc75642446d.svg";
export { ForwardRef as ReactComponent };